import { ApiEndpoints } from "../constants/apiEndpoints";
import apiClient from "../utils/apiClient";

class NotificationService {
  async listNotifications(params = {}) {
    const data = await apiClient.get(ApiEndpoints.NOTIFICATIONS, { params });
    return data?.notifications || data || [];
  }

  async markAsRead(notificationId) {
    return await apiClient.post(
      `${ApiEndpoints.NOTIFICATIONS}/${notificationId}/read`,
    );
  }

  async markAllAsRead() {
    return await apiClient.post(`${ApiEndpoints.NOTIFICATIONS}/read-all`);
  }

  async deleteNotification(notificationId) {
    return await apiClient.delete(
      `${ApiEndpoints.NOTIFICATIONS}/${notificationId}`,
    );
  }
}

const notificationService = new NotificationService();
export default notificationService;
export { notificationService };
